import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../shared/smartadmin.config';
import { AppState } from '../../app.service';

@Injectable()
export class HomeResolver implements Resolve<any> {
  constructor(private http: HttpClient, public appState: AppState) {}
  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const token = localStorage.getItem('authToken') ? localStorage.getItem('authToken') : sessionStorage.getItem('authToken');
    const headers = new HttpHeaders().set('authorization', token);
    headers.append('Content-Type', 'application/json');
    this.http.get(config.URL + '/profile/getProfile', {headers: headers, withCredentials: true}).subscribe((data: any) => {
      console.log('E', data);
      this.appState.set('role', data.role);
      this.appState.set('customer', data.customer);
      this.appState.set('username', data.name + ' ' + data.lastname)
      this.appState.set('theme', data.theme);
      return true;
    }, (err) => {
      return false;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/home.resolver.ts